import { css } from '@emotion/css';
import { useState } from 'react';
import accountStyles from './account-option.style';
import userApi from 'apis/userApi';
import toast from 'react-hot-toast';
import LoadingIcon from 'components/loading/LoadingIcon';
import { AgencyRefundItem } from 'models/agentModel';
import moment from 'moment';
import { IoMdClose } from 'react-icons/io';

interface Props {
    itemRecord: AgencyRefundItem;
    onClose: () => void;
}
function AgencyRefundDetail(props: Props) {
    const { itemRecord, onClose } = props;
    const [recordList, setRecordList] = useState({} as AgencyRefundItem);
    const [loading, setLoading] = useState(false);

    const searchFundDetail = async () => {
        setLoading(true);
        const payload = {
            gameId: itemRecord.gameId,
            date: itemRecord.sDate,
        };
        try {
            const { data } = await userApi.reportRefundMoney(payload);
            if (!data.msg) {
                toast.success("Nhận hoàn trả thành công");
                setRecordList((obj) => ({ ...obj, status: 1, refundDateSuccess: moment(new Date()).format('DD/MM/yyyy') }));
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.content}>
            <div className="btnClose" onClick={onClose}>
                <IoMdClose size={30} color='#fff' />
            </div>
            <h3>CHI TIẾT HOÀN TRẢ</h3>
            <div className="table-common">
                {recordList ? (
                    <div className="col-table">
                        <div className="row" key={recordList.gameId}>
                            <div className="col">
                                <p>Tên đăng nhập:</p>
                                <strong>{recordList.loginName}</strong>
                            </div>
                            <div className="col">
                                <p>Thể loại:</p>
                                <strong>{recordList.gameName}</strong>
                            </div>
                            <div className="col">
                                <p>Ngày cược:</p>
                                <strong>{recordList.sDate}</strong>
                            </div>
                            <div className="col">
                                <p>Tổng cược:</p>
                                <strong>{new Intl.NumberFormat().format(recordList.bettingAmount || 0)}</strong>
                            </div>
                            <div className="col">
                                <p>Chiết khấu:</p>
                                <strong>{recordList.discount}%</strong>
                            </div>
                            <div className="col">
                                <p>Tiền Hoàn trả:</p>
                                <strong>{new Intl.NumberFormat().format(recordList.promo || 0)}</strong>
                            </div>
                            {recordList.status === 0 && (
                                <div className="col">
                                    <p>Ngày nhận:</p>
                                    <strong>{moment(recordList.refundDateSuccess).format('DD/MM/yyyy')}</strong>
                                </div>
                            )}
                        </div>
                        {recordList.status === 1 && (
                            <div className={`${styles.elmSubmit}`}>
                                <button  onClick={searchFundDetail} className={`btn-primary ${accountStyles.btnSubmit}`}>
                                    Nhận hoàn trả
                                </button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="no-data">
                        <img src={require('assets/images/icons/no-data.png')} alt="" />
                        <p>Không có dữ liệu</p>
                    </div>
                )}
            </div>
            {loading && <LoadingIcon />}
        </div>
    );
}

const styles = {
    content: css`
        margin: 0 auto;
        width: 100%;
        min-height: 50vh;
        background: #2f60fb;
        border-radius: 20px;
        padding: 30px 20px;
        .btnClose {
            text-align: right;
        }
        h3 {
            text-align: center;
            color: #fff;
            margin: 20px;
        }
    `,
    elmSubmit: css`
        max-width: 40%;
        margin: 15px auto;
        p {
            color: #000;
            padding-bottom: 10px;
        }
    `,
};

export default AgencyRefundDetail;
